import { useCallback, useLayoutEffect, useMemo, useRef, useState } from "react";
import { VariableSizeList } from "react-window";
import { Task } from "model/activitiesModel";

export default function useMeasuredTaskRows(
  tasks: Task[],
  view: 'minimal' | 'compact' | 'extended',
  labelCompleteMode: boolean,
) {
  const listRef = useRef<VariableSizeList<Task>>(null);
  const [width, setWidth] = useState(0);
  // Layout or task changes invalidate measurements, including rows currently off screen.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const heights = useMemo(() => new Map<number, number>(), [tasks, view, labelCompleteMode, width]);
  const estimatedHeight = view === 'minimal' ? 64 : view === 'compact' ? 120 : 320;

  useLayoutEffect(() => {
    listRef.current?.resetAfterIndex(0);
  }, [heights]);

  const measureRow = useCallback((index: number, height: number) => {
    const task = tasks[index];
    if (!task || height <= 0 || heights.get(task.idprocesstoken) === height) return;
    heights.set(task.idprocesstoken, height);
    listRef.current?.resetAfterIndex(index);
  }, [tasks, heights]);

  const itemSize = useCallback((index: number) =>
    heights.get(tasks[index].idprocesstoken) ?? estimatedHeight,
  [tasks, heights, estimatedHeight]);

  const onResize = useCallback(({ width: nextWidth }: { width: number }) => setWidth(nextWidth), []);
  return { listRef, itemSize, measureRow, onResize };
}
